import React, { createContext, useContext, useState, useEffect } from 'react';

const QuoteContext = createContext(null);

function getQuotes() {
  const stored = localStorage.getItem('nc_quotes');
  return stored ? JSON.parse(stored) : [];
}

function saveQuotes(q) {
  localStorage.setItem('nc_quotes', JSON.stringify(q));
}

export function QuoteProvider({ children }) {
  const [quotes, setQuotes] = useState([]);

  useEffect(() => { setQuotes(getQuotes()); }, []);

  const submitQuote = (data) => {
    const q = {
      id: `QT-${Date.now()}`,
      ...data,
      status: 'Pending',
      submittedAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    const updated = [q, ...getQuotes()];
    saveQuotes(updated);
    setQuotes(updated);
    return q;
  };

  const updateQuoteStatus = (id, status) => {
    const updated = getQuotes().map(q =>
      q.id === id ? { ...q, status, updatedAt: new Date().toISOString() } : q
    );
    saveQuotes(updated);
    setQuotes(updated);
  };

  const getQuotesByEmail = (email) =>
    getQuotes().filter(q => q.email?.toLowerCase() === email?.toLowerCase());

  return (
    <QuoteContext.Provider value={{ quotes, submitQuote, updateQuoteStatus, getQuotesByEmail }}>
      {children}
    </QuoteContext.Provider>
  );
}

export function useQuote() { return useContext(QuoteContext); }
